import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Tooltip from "@mui/material/Tooltip";
import AdbIcon from "@mui/icons-material/Adb";
import LogoutIcon from "@mui/icons-material/Logout";
import { useUserAuth } from "../Context/UserAuthContext";
import { Button } from "@mui/material";
import { useLocation } from "react-router-dom";

const ResponsiveAppBar = () => {
  const { logOut } = useUserAuth();
  const pathname = useLocation().pathname
  return (
    <AppBar position="sticky">
      <Container maxWidth="lg">
        <Toolbar disableGutters>
          <AdbIcon sx={{ display: { xs: "none", md: "flex" }, mr: 1 }} />
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            STAY-ALERT ADMIN
          </Typography>
          <AdbIcon sx={{ display: { xs: "flex", md: "none" }, mr: 1 }} />
          <Typography
            variant="h5"
            noWrap
            component="a"
            href=""
            sx={{
              mr: 2,
              display: { xs: "flex", md: "none" },
              flexGrow: 1,
              fontFamily: "monospace",
              fontWeight: 600,
              fontSize: "15px",
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            STAY-ALERT ADMIN
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}></Box>
          <Button style={{ marginRight: "5px" }} variant={pathname === '/' ? 'contained':'text'} href="/">
            HOME
          </Button>
          <Button style={{ marginRight: "5px" }} variant={pathname === '/report' ? 'contained':'text'} href="/report">
            REPORT
          </Button>
          <Button style={{ marginRight: "5px" }} variant={pathname === '/user' ? 'contained':'text'} href="/user">
            USER
          </Button>
          <Button style={{ marginRight: "5px" }} variant={pathname === '/chats' ? 'contained':'text'} href="/chats">
            CHATS
          </Button>
          <Button style={{ marginRight: "20px" }} variant={pathname === '/alert-mode' ? 'contained':'text'} href="/alert-mode">
            Alert-Mode
          </Button>
          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Log-out">
              <IconButton onClick={logOut} sx={{ p: 0 }}>
                <LogoutIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default ResponsiveAppBar;
